module.exports = __webpack_public_path__ + "static/media/oops-404.5c1ac021.png";